import { css, cx } from 'linaria';
import { CrossIcon } from 'components/icons/CrossIcon';
import { useTranslation, Trans } from 'next-i18next';
const closeButtonStyles = "c16lr040";
export const CloseButton = ({
  handleClose,
  dataCy,
  closeButtonOverrides
}) => {
  const {
    t
  } = useTranslation();
  return <button data-cy={dataCy} className={cx('close', closeButtonStyles, closeButtonOverrides)} aria-label={t('common:close-label', 'Close')} onClick={handleClose}>
      <CrossIcon />
      <span className="visually-hidden">
        <Trans i18nKey="common:close">Close</Trans>
      </span>
    </button>;
};

require("./close-button.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./close-button.js");